<template>
  <div class="mt-4">
    <span class="d-flex align-items-center">
      <h5
        role="button"
        @click="isGRPFlughafenCollapsed = !isGRPFlughafenCollapsed"
        :aria-expanded="isGRPFlughafenCollapsed ? 'true' : 'false'"
        aria-controls="collapse-3"
        class="user-select-none mb-0"
      >
        <b-icon
          v-if="!isGRPFlughafenCollapsed"
          :scale="0.75"
          icon="chevron-right"
          aria-hidden="true"
        ></b-icon>
        <b-icon v-else :scale="0.75" icon="chevron-down" aria-hidden="true"></b-icon>
        Gruppeneinkauf
      </h5>
      <span v-if="!gruppenEinkaufExists" class="ml-3 plus-sign bg-primary" @click="addGruppeneinkauf">+</span>
    </span>
    <hr class="w-100 ml-0" />
    <b-collapse
      id="collapse-3"
      :class="isGRPFlughafenCollapsed ? null : 'collapsed'"
      v-model="isGRPFlughafenCollapsed"
    >
      <div v-if="gruppeneinkaeufe.length > 0">
        <div v-for="(grp, i) in gruppeneinkaeufe" :key="grp.id" class="mb-6">
          <h6 class="mb-4 ml-2">
            {{ i + 1 + '. Gruppeneinkauf' }}
            <span class="ml-4" @click="deleteGrpFlughafen(grp.id)" style="cursor: pointer">
              <i class="fas fa-trash" style="color: black"></i>
            </span>
          </h6>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">GRP Flughafen</h6>
            </b-list-group-item>
            <b-list-group-item
              class="col-6 d-flex align-items-center"
              :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'flughafenIataCode') }"
            >
              <AirportsSucheMultiselect
                class="w-100"
                v-model="grp.flughafenIataCode"
                :isMultipleAllowed="false"
                :openDirection="'top'"
                :filterCountry="reisetermin ? reisetermin.reise.reisekuerzel.substring(0, 2) : ''"
                :airportBlacklist="airportBlacklistFor(grp)"
                height="32px"
              ></AirportsSucheMultiselect>
            </b-list-group-item>
          </b-list-group>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">GRP PNR</h6>
            </b-list-group-item>
            <b-list-group-item
              class="col-6 d-flex align-items-center"
              :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'gruppePnr') }"
            >
              <b-form-input v-model="grp.gruppePnr" type="text" placeholder="-"></b-form-input>
            </b-list-group-item>
          </b-list-group>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">Eingekaufte Pax</h6>
            </b-list-group-item>
            <b-list-group-item
              class="col-6 d-flex align-items-center"
              :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'eingekauftePax') }"
            >
              <b-form-input v-model="grp.eingekauftePax" type="text" placeholder="-"></b-form-input>
            </b-list-group-item>
          </b-list-group>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">Flugnr. GRP Hin / Rück</h6>
            </b-list-group-item>
            <div class="d-flex w-100">
              <b-list-group-item
                class="col-6 d-flex align-items-center"
                :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'flugnummerGruppeHin') }"
              >
                <b-form-input v-model="grp.flugnummerGruppeHin" type="text" placeholder="-"></b-form-input>
              </b-list-group-item>
              <b-list-group-item
                class="col-6 d-flex align-items-center"
                :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'flugnummerGruppeRueck') }"
              >
                <b-form-input v-model="grp.flugnummerGruppeRueck" type="text" placeholder="-"></b-form-input>
              </b-list-group-item>
            </div>
          </b-list-group>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">OB / IB Class</h6>
            </b-list-group-item>
            <div class="d-flex w-100">
              <b-list-group-item
                class="col-6 d-flex align-items-center"
                :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'obClass') }"
              >
                <b-form-input v-model="grp.obClass" type="text" placeholder="-"></b-form-input>
              </b-list-group-item>
              <b-list-group-item
                class="col-6 d-flex align-items-center"
                :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'ibClass') }"
              >
                <b-form-input v-model="grp.ibClass" type="text" placeholder="-"></b-form-input>
              </b-list-group-item>
            </div>
          </b-list-group>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">Preis Netto</h6>
            </b-list-group-item>
            <b-list-group-item
              class="col-6 d-flex align-items-center"
              :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'hauptstreckePreisNetto') }"
            >
              <b-input-group class="d-flex align-items-center">
                <b-form-input
                  v-model="grp.hauptstreckePreisNetto"
                  type="number"
                  placeholder="-"
                ></b-form-input>
                <b-input-group-append>
                  <b-input-group-text style="height: 32px">€</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-list-group-item>
          </b-list-group>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">INFL Netto</h6>
            </b-list-group-item>
            <b-list-group-item
              class="col-6 d-flex align-items-center"
              :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'inlandsflugPreis') }"
            >
              <b-input-group class="d-flex align-items-center">
                <b-form-input v-model="grp.inlandsflugPreis" type="number" placeholder="-"></b-form-input>
                <b-input-group-append>
                  <b-input-group-text style="height: 32px">€</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-list-group-item>
          </b-list-group>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">Taxes Gesamt</h6>
            </b-list-group-item>
            <b-list-group-item
              class="col-6 d-flex align-items-center"
              :class="{ changed: isGruppeneinkaufFieldChanged(grp, 'taxesFlug') }"
            >
              <b-input-group class="d-flex align-items-center">
                <b-form-input v-model="grp.taxesFlug" type="number" placeholder="-"></b-form-input>
                <b-input-group-append>
                  <b-input-group-text style="height: 32px">€</b-input-group-text>
                </b-input-group-append>
              </b-input-group>
            </b-list-group-item>
          </b-list-group>

          <b-list-group horizontal class="bv-example-row">
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">Gesamtpreis GRP</h6>
            </b-list-group-item>
            <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut">
              <h6 class="m-0 leftLabel">
                {{
                  Number.isFinite(grp.gesamtpreisGruppeneinkauf)
                    ? (Math.round(grp.gesamtpreisGruppeneinkauf * 100) / 100).toLocaleString('de-DE', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      }) + '€'
                    : '-'
                }}
              </h6>
            </b-list-group-item>
          </b-list-group>
        </div>
      </div>
    </b-collapse>

    <DeleteConfirmationModal
      id="modalGrpFlughafenLoeschen"
      title="GRP Flughafen löschen?"
      entityBezeichnung="den GRP Flughafen"
      @confirm="confirmDeleteGrpFlughafen"
    />
  </div>
</template>

<script>
import apiService from '@/core/common/services/api.service';
import AirportsSucheMultiselect from '@/components/common/airports-suche-multiselect.vue';
import DeleteConfirmationModal from '@/components/common/delete-confirmation-modal.vue';

const TEMP_GRPFlughafen_ID = -1;

export default {
  name: 'SidebarFlugplanungGruppeneinkaeufe',
  components: {
    AirportsSucheMultiselect,
    DeleteConfirmationModal,
  },
  props: {
    // Der aktive Reisetermin liefert id, reiseterminkuerzel und das Zielland für den Flughafenfilter
    reisetermin: { type: Object, default: null },
  },
  data() {
    return {
      isGRPFlughafenCollapsed: false,
      // Lokale kopie der Gruppeneinkäufe
      gruppeneinkaeufe: [],
      pendingDeleteGrpFlughafenId: null,
    };
  },
  watch: {
    // Wechselt der Reisetermin, wird die kopie neu aus den geladenen Daten aufgebaut
    reisetermin: {
      immediate: true,
      handler() {
        this.syncFromReisetermin();
      },
    },
    // Änderungen an der kopie melden den Speicherzustand
    gruppeneinkaeufe: {
      deep: true,
      handler() {
        this.emitChanged();
      },
    },
    // Ändert sich die führende Flugnummer, wird der Airline-Bezug im Container ausgelöst
    flugnummerGruppeHin(newValue, oldValue) {
      this.$emit('leitflugnummer-changed', { newValue, oldValue });
    },
  },
  computed: {
    // Führende Flugnummer Hin
    flugnummerGruppeHin() {
      if (!this.gruppeneinkaeufe || this.gruppeneinkaeufe.length === 0) {
        return null;
      }
      // Nur gespeicherte Einträge berücksichtigen, keine temporären
      const savedEntries = this.gruppeneinkaeufe.filter(grp => !grp.isTemporary);

      if (savedEntries.length > 0) {
        return savedEntries[0]?.flugnummerGruppeHin;
      }

      return this.gruppeneinkaeufe[0]?.flugnummerGruppeHin;
    },
    // Prüft, ob ein temporärer Gruppeneinkauf existiert -> steuert den +-Button
    gruppenEinkaufExists() {
      return this.gruppeneinkaeufe?.some(grp => grp?.isTemporary === true);
    },
    // Der aktuell in Bearbeitung befindliche temporäre Gruppeneinkauf
    temporaererGruppeneinkauf() {
      return this.gruppeneinkaeufe?.find(grp => grp?.isTemporary === true);
    },
    // Prüft, ob der temporäre Gruppeneinkauf alle Pflichtfelder befüllt hat
    readyToSaveGruppeneinkauf() {
      if (!this.temporaererGruppeneinkauf) return false;

      const grp = this.temporaererGruppeneinkauf;

      // flughafenIataCode ist das einzige Pflichtfeld
      return grp.flughafenIataCode !== null;
    },
    // Liefert alle geänderten, nicht-temporären und vollständig befüllten Gruppeneinkäufe
    gruppeneinkauefChanged() {
      return this.gruppeneinkaeufe.filter(grp => {
        if (grp.isTemporary || !grp.valuesBeforeEdit) return false;

        // Erst prüfen ob geändert
        const hasChanges =
          grp.flughafenIataCode !== grp.valuesBeforeEdit.flughafenIataCode ||
          grp.gruppePnr !== grp.valuesBeforeEdit.gruppePnr ||
          grp.eingekauftePax !== grp.valuesBeforeEdit.eingekauftePax ||
          grp.flugnummerGruppeHin !== grp.valuesBeforeEdit.flugnummerGruppeHin ||
          grp.flugnummerGruppeRueck !== grp.valuesBeforeEdit.flugnummerGruppeRueck ||
          grp.obClass !== grp.valuesBeforeEdit.obClass ||
          grp.ibClass !== grp.valuesBeforeEdit.ibClass ||
          grp.hauptstreckePreisNetto !== grp.valuesBeforeEdit.hauptstreckePreisNetto ||
          grp.inlandsflugPreis !== grp.valuesBeforeEdit.inlandsflugPreis ||
          grp.taxesFlug !== grp.valuesBeforeEdit.taxesFlug;

        if (!hasChanges) return false;

        // Nur GRP Flughafen ist Pflichtfeld
        const isComplete =
          grp.flughafenIataCode !== null &&
          grp.flughafenIataCode !== undefined &&
          grp.flughafenIataCode !== '';

        return isComplete;
      });
    },
    // Prüft ob sich ein Feld in der Gruppe geändert hat oder bei neuen Gruppen einen Wert hat
    isGruppeneinkaufFieldChanged() {
      return (gruppe, feldName) => {
        // Keine Gruppe = keine Änderung
        if (!gruppe) return false;

        // Bei neuen/temporären Gruppen: markiere als geändert wenn Wert vorhanden
        if (gruppe.isTemporary || !gruppe.valuesBeforeEdit) {
          const wert = gruppe[feldName];
          return wert !== null && wert !== undefined && wert !== '';
        }

        // Bei bestehenden Gruppen: vergleiche mit ursprünglichem Wert
        return gruppe[feldName] !== gruppe.valuesBeforeEdit[feldName];
      };
    },
  },
  mounted() {
    if (this.flugnummerGruppeHin != null) {
      this.$emit('leitflugnummer-changed', { newValue: this.flugnummerGruppeHin, oldValue: null });
    }
  },
  methods: {
    syncFromReisetermin() {
      const source = this.reisetermin?.flugeinkauf?.gruppeneinkaeufe ?? [];
      this.gruppeneinkaeufe = source.map(grp => {
        if (grp.isTemporary) {
          return { ...grp };
        }
        return {
          ...grp,
          valuesBeforeEdit: {
            flughafenIataCode: grp.flughafenIataCode,
            gruppePnr: grp.gruppePnr,
            eingekauftePax: grp.eingekauftePax,
            flugnummerGruppeHin: grp.flugnummerGruppeHin,
            flugnummerGruppeRueck: grp.flugnummerGruppeRueck,
            obClass: grp.obClass,
            ibClass: grp.ibClass,
            hauptstreckePreisNetto: grp.hauptstreckePreisNetto,
            inlandsflugPreis: grp.inlandsflugPreis,
            taxesFlug: grp.taxesFlug,
          },
        };
      });
    },
    emitChanged() {
      this.$emit('changed', {
        hasChanges: this.readyToSaveGruppeneinkauf || this.gruppeneinkauefChanged.length > 0,
        isValid: true,
      });
    },
    // Flughäfen der anderen Gruppeneinkäufe, damit ein Flughafen nicht mehrfach gewählt werden kann
    airportBlacklistFor(grp) {
      return this.gruppeneinkaeufe.filter(g => g.id !== grp.id).map(g => g.flughafenIataCode);
    },
    // Zeigt die leere Hülle des Gruppeneinkaufes in der UI an
    addGruppeneinkauf() {
      this.isGRPFlughafenCollapsed = true;
      if (!this.gruppenEinkaufExists) {
        this.gruppeneinkaeufe.unshift({
          isOnlyLocal: true,
          isTemporary: true,
          id: TEMP_GRPFlughafen_ID,
          flughafenIataCode: null,
          gruppePnr: null,
          eingekauftePax: null,
          flugnummerGruppeHin: null,
          flugnummerGruppeRueck: null,
          obClass: null,
          ibClass: null,
          hauptstreckePreisNetto: null,
          inlandsflugPreis: null,
          taxesFlug: null,
          valuesBeforeEdit: {
            flughafenIataCode: null,
            gruppePnr: null,
            eingekauftePax: null,
            flugnummerGruppeHin: null,
            flugnummerGruppeRueck: null,
            obClass: null,
            ibClass: null,
            hauptstreckePreisNetto: null,
            inlandsflugPreis: null,
            taxesFlug: null,
          },
        });
      }
    },
    // Startet das Löschen eines Gruppeneinkaufs
    deleteGrpFlughafen(id) {
      // wenn es nur ein temporärer ist, entferne ihn
      if (id === TEMP_GRPFlughafen_ID) {
        this.gruppeneinkaeufe = this.gruppeneinkaeufe.filter(grp => grp.id !== id);
        return;
      }

      this.pendingDeleteGrpFlughafenId = id;
      this.$bvModal.show('modalGrpFlughafenLoeschen');
    },
    // Löscht den bestätigten Gruppeneinkauf per API und entfernt ihn
    confirmDeleteGrpFlughafen() {
      this.$bvModal.hide('modalGrpFlughafenLoeschen');
      const id = this.pendingDeleteGrpFlughafenId;
      if (id === null) return;

      this.$emit('loading', true);

      // Löscht über den Flughafen-Code statt über die Gruppeneinkauf-ID
      const grpToDelete = this.gruppeneinkaeufe.find(grp => grp.id === id);
      apiService
        .post('/Reisetermin/bulkDeleteGruppeneinkauf', {
          reiseterminIds: [this.reisetermin?.id],
          flughafenIataCode: grpToDelete?.flughafenIataCode,
        })
        .then(() => {
          this.toast('Erfolgreich gelöscht');
          this.gruppeneinkaeufe = this.gruppeneinkaeufe.filter(grp => grp.id !== id);
          this.$emit('deletedGrpFlughafen', {
            reiseterminkuerzel: this.reisetermin.reiseterminkuerzel,
            id,
          });
        })
        .finally(() => {
          this.$emit('loading', false);
          this.pendingDeleteGrpFlughafenId = null;
        });
    },
    // Speichermethode
    async save() {
      // Gruppeneinkauf speichern wenn bereit
      if (this.readyToSaveGruppeneinkauf) {
        await this.saveGruppeneinkauf();
      }

      // Geänderte Gruppeneinkäufe speichern
      if (this.gruppeneinkauefChanged.length > 0) {
        let changedCount = 0;
        for (const grp of this.gruppeneinkauefChanged) {
          await this.saveChangedGruppeneinkauf(grp);
          changedCount++;
        }
        this.toast(`${changedCount} Gruppeneinkauf${changedCount > 1 ? 'e' : ''} erfolgreich aktualisiert.`);
      }
    },
    // Legt den temporären Gruppeneinkauf per API neu an
    async saveGruppeneinkauf() {
      const grp = this.temporaererGruppeneinkauf;
      if (!grp) return;

      const params = {
        flughafenIataCode: grp.flughafenIataCode,
        gruppePnr: grp.gruppePnr,
        eingekauftePax: Number(grp.eingekauftePax),
        flugnummerGruppeHin: grp.flugnummerGruppeHin,
        flugnummerGruppeRueck: grp.flugnummerGruppeRueck,
        obClass: grp.obClass,
        ibClass: grp.ibClass,
        hauptstreckePreisNetto: Number(grp.hauptstreckePreisNetto),
        inlandsflugPreis: Number(grp.inlandsflugPreis),
        taxesFlug: Number(grp.taxesFlug),
      };

      try {
        // Für die Sidebar wird nur ein einzelner Termin übergeben (Array mit einer ID)
        const response = await apiService.post('/Reisetermin/bulkCreateGruppeneinkauf', {
          reiseterminIds: [this.reisetermin?.id],
          gruppeneinkaufDto: params,
        });
        const newGruppeneinkauf = response.data.result;

        // Entferne temporären Gruppeneinkauf
        this.gruppeneinkaeufe = this.gruppeneinkaeufe.filter(grp => !grp?.isTemporary);

        // valuesBeforeEdit für neuen Gruppeneinkauf setzen
        newGruppeneinkauf.valuesBeforeEdit = {
          flughafenIataCode: newGruppeneinkauf.flughafenIataCode,
          gruppePnr: newGruppeneinkauf.gruppePnr,
          eingekauftePax: newGruppeneinkauf.eingekauftePax,
          flugnummerGruppeHin: newGruppeneinkauf.flugnummerGruppeHin,
          flugnummerGruppeRueck: newGruppeneinkauf.flugnummerGruppeRueck,
          obClass: newGruppeneinkauf.obClass,
          ibClass: newGruppeneinkauf.ibClass,
          hauptstreckePreisNetto: newGruppeneinkauf.hauptstreckePreisNetto,
          inlandsflugPreis: newGruppeneinkauf.inlandsflugPreis,
          taxesFlug: newGruppeneinkauf.taxesFlug,
        };

        this.gruppeneinkaeufe.push(newGruppeneinkauf);

        this.toast('Gruppeneinkauf erfolgreich gespeichert.');

        this.$emit('createdGruppeneinkauf', {
          reiseterminkuerzel: this.reisetermin.reiseterminkuerzel,
          newGruppeneinkauf,
        });
        this.$emit('newGruppeneinkauf', newGruppeneinkauf);
      } catch (error) {
        // Entferne temporären Gruppeneinkauf im Fehlerfall
        this.gruppeneinkaeufe = this.gruppeneinkaeufe.filter(grp => !grp?.isTemporary);
        throw error;
      }
    },
    // Speichert einen bereits bestehenden, geänderten Gruppeneinkauf
    async saveChangedGruppeneinkauf(grp) {
      const params = {
        flughafenIataCode: grp.flughafenIataCode,
        gruppePnr: grp.gruppePnr,
        eingekauftePax: Number(grp.eingekauftePax),
        flugnummerGruppeHin: grp.flugnummerGruppeHin,
        flugnummerGruppeRueck: grp.flugnummerGruppeRueck,
        obClass: grp.obClass,
        ibClass: grp.ibClass,
        hauptstreckePreisNetto: Number(grp.hauptstreckePreisNetto),
        inlandsflugPreis: Number(grp.inlandsflugPreis),
        taxesFlug: Number(grp.taxesFlug),
      };

      // Identifiziert den Gruppeneinkauf über den flughafenIataCode statt über die ID
      const response = await apiService.put('/Reisetermin/bulkUpdateGruppeneinkauf', {
        reiseterminIds: [this.reisetermin?.id],
        gruppeneinkaufDto: params,
      });

      // Update valuesBeforeEdit nach erfolgreichem Speichern
      grp.valuesBeforeEdit = {
        flughafenIataCode: grp.flughafenIataCode,
        gruppePnr: grp.gruppePnr,
        eingekauftePax: grp.eingekauftePax,
        flugnummerGruppeHin: grp.flugnummerGruppeHin,
        flugnummerGruppeRueck: grp.flugnummerGruppeRueck,
        obClass: grp.obClass,
        ibClass: grp.ibClass,
        hauptstreckePreisNetto: grp.hauptstreckePreisNetto,
        inlandsflugPreis: grp.inlandsflugPreis,
        taxesFlug: grp.taxesFlug,
      };

      this.$emit('updatedGruppeneinkauf', {
        reiseterminkuerzel: this.reisetermin.reiseterminkuerzel,
        gruppeneinkauf: grp,
      });

      return response;
    },
  },
};
</script>

<style scoped>
.detailLabelGreyedOut {
  background-color: rgba(114, 114, 114, 0.05);
  border-style: solid;
  border-color: rgba(114, 114, 114, 0.15);
}

.leftLabel {
  font-size: 1.05rem;
  font-weight: 500;
}

:deep(.form-control) {
  height: 32px !important;
}

.list-group {
  height: 42px;
}

.plus-sign {
  height: 24px;
  width: 24px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: white;
  cursor: pointer;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}

.changed {
  background-color: #3699ff50;
}
</style>
